export const referEarnWhitePageBgImage = require('./white-theme-assets/page-bg.webp');
export const referEarnWhiteReferralPageBgImage = require('./white-theme-assets/referral-page-bg.webp');
export const referEarnWhitePanelBgImage = require('./white-theme-assets/panel-bg.webp');
export const referEarnWhiteAgentTreeImage = require('./white-theme-assets/agent-tree.webp');
